<table mat-table [dataSource]="startupActs">
  <ng-container *ngFor="let column of headerColumns; let i = index" [matColumnDef]="column.name">
    <th mat-header-cell *matHeaderCellDef>
      {{ column.label }}
    </th>
    <td mat-cell *matCellDef="let row" nowrap>
      <ng-container [ngSwitch]="column.type">
        <ng-container *ngSwitchCase="'input'">
          <ng-container *ngIf="column.editable; else readOnlyInput">
            <div class="form-input" [ngClass]="{ editing: editableField.focused }">
              <input class="installation-input" matInput #editableField="matInput" [(ngModel)]="row[column.name]"
                (ngModelChange)="onChangeEditable($event, row, column.name)" [value]="row[column.name]" />
              <bdr-icon icon="ico-edit" size="10"></bdr-icon>
            </div>
          </ng-container>
          <ng-template #readOnlyInput>{{ row[column.name] }}</ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="'select'">
          <ng-container *ngIf="column.editable; else readOnlySelect">
            <mat-select
              class="selector-field"
              panelClass="selector-panel"
              [(ngModel)]="row[column.name]"
              (ngModelChange)="onChangeEditable($event, row, column.name)">
              <mat-option [value]="null"></mat-option>
              <mat-option *ngFor="let option of getSelectOptions(column)" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </ng-container>
          <ng-template #readOnlySelect>{{ row[column.name] }}</ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="'date'">
          <ng-container *ngIf="column.editable; else readOnlyDate">
            <div class="form-input" [ngClass]="{ editing: editableDateField.focused }">
              <input
                class="installation-input"
                matInput
                #editableDateField="matInput"
                type="date"
                [(ngModel)]="row[column.name]"
                (ngModelChange)="onChangeEditable($event, row, column.name)"
                [value]="row[column.name]"
              />
              <bdr-icon icon="ico-edit" size="10"></bdr-icon>
            </div>
          </ng-container>
          <ng-template #readOnlyDate>{{ row[column.name] }}</ng-template>
        </ng-container>

        <ng-container *ngSwitchDefault>{{ row[column.name] }}</ng-container>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>